<template>
  <provider-countries-view :discountCountries="discountsCountries" :countries="countries" />
</template>

<style scoped>

</style>

<script>
import { mapState } from 'vuex';
import ProviderCountriesView from './ProviderCountriesView.vue';

export default {
  name: 'provider-countries',
  props: {
    discounts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    discountsCountries() {
      const countryArrays = this.discounts.map((discount) => discount.countryGeoIds);
      let countries = [];
      countryArrays.forEach((array) => {
        countries = countries.concat(array);
      });
      return countries.filter((value, index, self) => self.indexOf(value) === index);
    },
    ...mapState({
      countries: (state) => state.country.list,
    }),
  },
  components: {
    ProviderCountriesView,
  },
};
</script>
